import { render, staticRenderFns } from "./Detalhe_Corretor.vue?vue&type=template&id=6a1d68f4&scoped=true&"
import script from "./Detalhe_Corretor.vue?vue&type=script&lang=js&"
export * from "./Detalhe_Corretor.vue?vue&type=script&lang=js&"
import style0 from "./Detalhe_Corretor.vue?vue&type=style&index=0&id=6a1d68f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1d68f4",
  null
  
)

export default component.exports